module.exports = __webpack_public_path__ + "img/earth.62b58e20.svg";